/** The API's rule for an address staff type (`SurveyAnswerValidatorV3.EMAIL_PATTERN`): something@something.tld. */
export const INVITE_EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

/** The invite and email dialogs: 600 (sm) cramps the guest rows and the mail preview, 900 (md) is too wide. */
export const SHARE_DIALOG_MAX_WIDTH = 720;
